import { ICircleSpinnerProps } from "interfaces";

const CircleSpinner = ({ className }: ICircleSpinnerProps) => {
    return (
        <div className={`pl-animate-spin pl-flex pl-items-center pl-w-6 pl-h-6 pl-border-[2px] pl-border-current pl-border-t-transparent pl-text-blue-600 pl-rounded-full ${className}`} role="status" aria-label="loading">
            <span className="pl-sr-only">Loading...</span>
        </div>
    )
}

export default CircleSpinner;